export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Рядок від"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["до"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["символів"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Недопустиме значення"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Обов'язкове поле"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перевірте поля"])}
}